import { render, staticRenderFns } from "./ClipFolderSkeleton.vue?vue&type=template&id=00df17a3"
import script from "./ClipFolderSkeleton.vue?vue&type=script&lang=js"
export * from "./ClipFolderSkeleton.vue?vue&type=script&lang=js"
import style0 from "./ClipFolderSkeleton.vue?vue&type=style&index=0&id=00df17a3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VSkeletonLoader})
